// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"87":"5994427a","128":"cc51c1b6","811":"0f2a52b5"}[chunkId] + ".js";
};